// enableArrowFocusRegion.ts
export function enableArrowFocusRegion(el: HTMLElement): () => void {
  if (!el || typeof el.addEventListener !== "function") {
    return () => {};
  }

  const selector = 'a[tabindex], button:not([disabled]), [role="link"][tabindex]';

  const getItems = (): HTMLElement[] => {
    return Array.from(el.querySelectorAll<HTMLElement>(selector)).filter((node) => {
      const style = window.getComputedStyle(node);
      return style.display !== "none" && style.visibility !== "hidden";
    });
  };

  const onKeydown = (e: KeyboardEvent) => {
    // Only act if focus is within the region
    const active = document.activeElement as HTMLElement | null;
    if (!active || !el.contains(active)) return;

    const items = getItems();
    if (items.length <= 1) return;

    const currentIndex = items.indexOf(active);
    let nextIndex = currentIndex;

    switch (e.key) {
      case "ArrowDown":
      case "ArrowRight":
        nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % items.length;
        break;

      case "ArrowUp":
      case "ArrowLeft":
        nextIndex =
          currentIndex === -1 ? items.length - 1 : (currentIndex - 1 + items.length) % items.length;
        break;

      case "Home":
        nextIndex = 0;
        break;

      case "End":
        nextIndex = items.length - 1;
        break;

      case "Escape":
        el.focus();
        return;

      default:
        return;
    }

    e.preventDefault();
    items[nextIndex].focus();
  };

  el.addEventListener("keydown", onKeydown);

  // cleanup
  return () => {
    el.removeEventListener("keydown", onKeydown);
  };
}
